<template>
  <article-detail-page />
</template>

<script setup lang="ts">
  definePageMeta({ layout: 'default' })
</script>
